<template>
  <v-sheet :class="{ disabled }">
    <v-sheet class="pt-0">
      <label for="text-area" class="field-lable grey--text text--darken-1">
        {{ config.label }}
        <v-btn
          class="text-capitalize"
          depressed
          color="grey lighten-4"
          :disabled="disabled"
          @click="toggleModal"
          style="margin: 5px 0"
          >Edit</v-btn
        >
      </label>
      <v-sheet
        outlined
        rounded
        class="overflow-auto pa-2 mt-2"
        :class="{ 'border-grey': !disabled }"
        min-height="40"
        max-height="200"
        v-html="value.html"
        :disabled="disabled"
        @click="toggleModal"
      ></v-sheet>
    </v-sheet>
    <br />
    <v-sheet v-if="config.hasAnchorPosition" class="pt-0">
      <label for="select" class="grey--text text--darken-1">Anchor position</label>
      <v-select
        :value="selectedAnchorPosition"
        :items="anchorPositions"
        :disabled="disabled || !value.html"
        @change="$emit('setAnchorPosition', $event)"
        item-text="name"
        item-value="value"
        outlined
        dense
        class="mt-2"
      ></v-select>
    </v-sheet>
    <html-modal
      :title="config.title"
      :label="config.label"
      :placeholder="config.placeholder"
      v-model="modal"
      :data="value"
      @submit="$emit('input', $event)"
    />
  </v-sheet>
</template>
<script lang="ts">
  import Vue from 'vue';
  import HtmlModal from './HtmlModal.vue';
  import { HTML_ANCHOR_POSITIONS } from '../../constants/htmlAnchorPositions';
  export default Vue.extend({
    name: 'HtmlBlock',
    components: {
      HtmlModal,
    },
    props: {
      disabled: {
        type: Boolean,
        required: false,
      },
      config: {
        type: Object,
        required: true,
      },
      value: {
        type: Object,
        required: true,
      },
      selectedAnchorPosition: {
        type: Number,
        required: false,
      },
    },
    data() {
      return {
        modal: false,
      };
    },
    computed: {
      preview(): string {
        return this.value.html;
      },
      anchorPositions(): Array<{ name: string; value: number }> {
        return Object.values(HTML_ANCHOR_POSITIONS);
      },
    },
    methods: {
      toggleModal() {
        this.modal = !this.modal;
      },
    },
  });
</script>
<style scoped lang="scss">
  .border-grey {
    border-color: rgba(0, 0, 0, 0.38) !important;

    &:hover {
      border-color: rgba(0, 0, 0, 0.86) !important;
    }
  }
  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .field-lable {
    display: flex;
    justify-content: space-between;
    align-items: end;
  }
</style>
